import { Box, Container } from '@mui/material';
import FormBuilder from './FormBuilder';

const FormBuilderPage = () => {
  return (
    <Box>
      <FormBuilder />
    </Box>
  );
};

export default FormBuilderPage;
